<nav id="navbar" class="">
    <div class="nav-wrapper">
      <!-- Navbar Logo -->
    <div class="logo">
       <a href="https://www.flysas.com/" target="_blank"><span class="sas-wifi-icon">&nbsp;</span></a>
      </div>
      <!-- Navbar Links -->
      <div class="menu-border">
         <a href="https://www.flysas.com/" target="_blank"><span class="text-white mrgn-tp-27">Go to SAS website</span><div class="sas-globe-icon">&nbsp;</div></a>
    </div>
  </div>
  </nav>
